export default "__VITE_ASSET__00f8950e__"